var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87.582,
    height: 135.56,
    viewBox: "101.184 51.6084 87.582 135.56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.62 53.6084H162.33C168.966 53.6084 174.338 55.7151 178.446 59.9284C182.659 64.0364 184.766 69.4084 184.766 76.0444V146.196C184.766 152.2 183.08 157.204 179.71 161.206C176.828 164.539 173.099 166.754 168.523 167.853C167.294 168.149 166.524 169.428 166.954 170.617L170.524 180.488C170.996 181.792 170.03 183.168 168.643 183.168H155.047C154.203 183.168 153.449 182.638 153.164 181.844L148.901 169.957C148.616 169.162 147.862 168.632 147.018 168.632H123.62C116.984 168.632 111.559 166.578 107.346 162.47C103.238 158.257 101.184 152.832 101.184 146.196V76.0444C101.184 69.4084 103.238 64.0364 107.346 59.9284C111.559 55.7151 116.984 53.6084 123.62 53.6084ZM149.872 127.552C150.711 127.552 151.461 128.077 151.75 128.865L157.755 145.28C158.109 146.247 159.184 146.839 160.037 146.26C161.355 145.366 162.014 143.87 162.014 141.772V80.4684C162.014 76.8871 160.223 75.0964 156.642 75.0964H129.308C125.726 75.0964 123.936 76.8871 123.936 80.4684V141.772C123.936 145.354 125.726 147.144 129.308 147.144H137.672C139.06 147.144 140.025 145.766 139.552 144.462L134.389 130.235C133.916 128.931 134.882 127.552 136.269 127.552H149.872Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.62 53.6084H162.33C168.966 53.6084 174.338 55.7151 178.446 59.9284C182.659 64.0364 184.766 69.4084 184.766 76.0444V146.196C184.766 152.2 183.08 157.204 179.71 161.206C176.828 164.539 173.099 166.754 168.523 167.853C167.294 168.149 166.524 169.428 166.954 170.617L170.524 180.488C170.996 181.792 170.03 183.168 168.643 183.168H155.047C154.203 183.168 153.449 182.638 153.164 181.844L148.901 169.957C148.616 169.162 147.862 168.632 147.018 168.632H123.62C116.984 168.632 111.559 166.578 107.346 162.47C103.238 158.257 101.184 152.832 101.184 146.196V76.0444C101.184 69.4084 103.238 64.0364 107.346 59.9284C111.559 55.7151 116.984 53.6084 123.62 53.6084ZM149.872 127.552C150.711 127.552 151.461 128.077 151.75 128.865L157.755 145.28C158.109 146.247 159.184 146.839 160.037 146.26C161.355 145.366 162.014 143.87 162.014 141.772V80.4684C162.014 76.8871 160.223 75.0964 156.642 75.0964H129.308C125.726 75.0964 123.936 76.8871 123.936 80.4684V141.772C123.936 145.354 125.726 147.144 129.308 147.144H137.672C139.06 147.144 140.025 145.766 139.552 144.462L134.389 130.235C133.916 128.931 134.882 127.552 136.269 127.552H149.872Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0q",
    x: 101.184,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 142.975,
    y1: 53.6084,
    x2: 222.647,
    y2: 144.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueen);
export default __webpack_public_path__ + "static/media/queen.ae9136bff7f871e5af6722e3c152b0ee.svg";
export { ForwardRef as ReactComponent };